export * from "./component-name";
